import router, { routerAuthFlattened } from './router';
import store from './store';
import { Message, MessageBox } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { _ } from 'core-js';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  '/login',
  '/qq-maps',
  '/registerAgreement',
  '/privacyAgreement',
  '/mini/privacyAgreement',
]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  console.log('我是登录过的1')
  // start progress bar
  NProgress.start();

  // set page title
  // 如果路由配置了title或titleFn，优先titleFn
  let title = '';
  if (to.meta) {
    title = to.meta.title;
    if (to.meta.titleFn) {
      title = to.meta.titleFn(to);
    }
  }
  document.title = getPageTitle(title);

  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    console.log('to.path', to.path)
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      // next({ path: '/' });
      store.dispatch('user/getWhiteStatus', {
        sellerId: store.getters.sellerId
      })
      NProgress.done();
    } else {
      // 重新获取配置信息
      // baseSeller/constant

      const hasGetUserInfo = store.getters.sellerId;
      const isWhiteList = store.getters.isWhiteList
      console.log(store.getters, 'store.getters')
      if (hasGetUserInfo) {
        console.log('我是登录过的')
        // if (hasWhiteList === undefined) {
        //   // store.dispatch('user/getWhiteStatus')
        // }
        const promiseList = [
          store.dispatch('user/getConstantInfo'),
          store.dispatch('user/getMenuInfo'),
        ]
        if (isWhiteList === undefined) {
          promiseList.push(store.dispatch('user/getWhiteStatus', {
            sellerId: hasGetUserInfo
          }))
        }
        await Promise.all(promiseList);

        if (!to.name) {
          // 跳过login等
          next();
        } else {
          const sellerBookingType = store.getters.sellerBookingType;
          const hasAuth =
            sellerBookingType === 1 ? hasStoreAuthMenu(to) : hasAuthMenu(to);
          if (hasAuth) {
            next();
          } else {
            // next({ path: '/' });
            store.dispatch('user/getWhiteStatus', {
              sellerId: store.getters.sellerId
            })
            // if (!to.path.contains('shop-situation')) {
            if (!to.path.includes('shop-situation')) {
              await MessageBox({
                type: 'info',
                message: '您暂无使用该功能的权限',
                closeOnClickModal: false,
                confirmButtonText: '知道了',
              });
            }
          }
          NProgress.done();
        }
      } else {
        try {
          // get user info
          // await store.dispatch('user/getInfo')

          next();
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken');
          Message.error(error || 'Has Error');
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/
    window.localStorage.setItem('sellerBookingType', 0); // 清除登录状态后，默认切换到直邮商城
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
export const hasAuthMenu = to => {
  // 手动推送订单，大丸百货专属
  const item = routerAuthFlattened.find(t => t.name === to.name);
  if (!item) {
    return false;
  }

  // 该路由的父级或其本身在其权限列表里，则有权限
  const hasAuth =
    !_.isEmpty(_.intersection(item.parentList, store.getters.menuCodeList)) ||
    store.getters.menuCodeList.includes(to.name);
  return hasAuth;
};

export const hasStoreAuthMenu = to => {
  // 手动推送订单，大丸百货专属
  const item = routerAuthFlattened.find(t => t.name === to.name);
  if (!item) {
    return false;
  }

  // 该路由的父级或其本身在其权限列表里，则有权限
  const hasAuth =
    !_.isEmpty(
      _.intersection(item.parentList, store.getters.storeMenuCodeList)
    ) || store.getters.storeMenuCodeList.includes(to.name);
  return hasAuth;
};

export const filterStoreAuthMenu = to => {
  // 手动推送订单，大丸百货专属
  const item = routerAuthFlattened.find(t => t.name === to.name);
  if (!item) {
    return false;
  }

  // 该路由的父级或其本身在其权限列表里，则有权限
  const hasAuth = store.getters.storeMenuCodeList.includes(to.name);
  return hasAuth;
};
// 供应商权限
export const supplierMenu = to => {
  // 该路由的父级或其本身在其权限列表里，则有权限
  const hasAuth = store.getters.supplierMenuInfo.includes(to.name);
  return hasAuth;
};
